import React from 'react';
import { Skeleton } from '@mui/material';
import { Container, Row } from './styles';

const SkeletonTrackingCard = () => {
  return (
    <Container>
      <Row>
        <Skeleton
          variant="rectangular"
          height="64px"
          width="30%"
          animation="wave"
          style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px'  }}
        />
        <Skeleton
          variant="rectangular"
          height="64px"
          width="70%"
          animation="wave"
        />
        <Skeleton
          variant="rectangular"
          height="64px"
          width="15%"
          animation="wave"
          style={{ borderTopRightRadius: '4px', borderBottomRightRadius: '4px'  }}
        />
      </Row>
      <Row>
        <Skeleton
          variant="rectangular"
          height="164px"
          width="26%"
          animation="wave"
        />
        <Skeleton
          variant="rectangular"
          height="164px"
          width="74%"
          animation="wave"
        />
      </Row>
    </Container>
  );
};

export default SkeletonTrackingCard;
